import { Minus, Plus } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import useNumberSpinner from "common/hooks/useNumberSpinner";

interface SummaryProps {
  quantity: number;
  setQuantity: (newQuantity: number) => void;
  minValue: number;
  maxValue: number;
}

export default function QuantitySelector({
  quantity,
  setQuantity,
  minValue,
  maxValue,
}: SummaryProps) {
  const { inputProps, incrementButtonProps, decrementButtonProps } =
    useNumberSpinner(quantity, setQuantity, minValue, maxValue);

  return (
    <div className="mb-4 flex items-center justify-between gap-x-6 rounded-3xl bg-purple-100 px-6 py-2 ring ring-purple-200">
      <Button
        intent="iconOnly"
        variant="secondary-purple"
        {...decrementButtonProps}
      >
        <Minus />
      </Button>

      <input
        className="h-10 w-full rounded-2xl bg-white text-center text-md-bold text-black-700 [appearance:textfield] focus:outline-none"
        {...inputProps}
      />

      <Button
        intent="iconOnly"
        variant="secondary-purple"
        {...incrementButtonProps}
      >
        <Plus />
      </Button>
    </div>
  );
}
